import React, { useMemo } from 'react';

import TaskStatusPill from '@/src/components/project/Common/TaskStatusPill';
import { UpdatedTaskStatusEnum } from '@/src/components/task/Config';
import clsx from 'clsx';
import EmployeeAvatar from '@/src/components/project/Processes2/components/Table/Elements/EmployeeAvatar';

const getUser = (task) => {
  const {
    reviewerAvatar,
    reviewerName,
    reviewerPosition,
    reviewerId,
    approverAvatar,
    approverName,
    approverPosition,
    approverId,
    assigneeAvatar,
    assigneeName,
    assigneePosition,
    assigneeId,
    taskStatus,
  } = task;

  if (taskStatus === UpdatedTaskStatusEnum.ToReview) {
    return {
      avatar: reviewerAvatar,
      name: reviewerName,
      position: reviewerPosition,
      id: reviewerId,
    };
  }
  if (taskStatus === UpdatedTaskStatusEnum.ToApprove) {
    return {
      avatar: approverAvatar,
      name: approverName,
      position: approverPosition,
      id: approverId,
    };
  }
  if (taskStatus === UpdatedTaskStatusEnum.Approved) {
    return approverId
      ? { avatar: approverAvatar, name: approverName, position: approverPosition, id: approverId }
      : approverId !== null
        ? { avatar: assigneeAvatar, name: assigneeName, position: assigneePosition, id: assigneeId }
        : {
            avatar: 'default.png',
            name: 'None',
            position: 'None',
            id: 'None',
          };
  }
  return { avatar: assigneeAvatar, name: assigneeName, position: assigneePosition, id: assigneeId };
};

const Assignee = ({ task, hideTags = false, ...props }) => {
  const user = useMemo(
    () => getUser(task),
    [
      task?.reviewerAvatar,
      task?.reviewerName,
      task?.reviewerPosition,
      task?.reviewerId,
      task?.approverAvatar,
      task?.approverName,
      task?.approverPosition,
      task?.approverId,
      task?.assigneeAvatar,
      task?.assigneeName,
      task?.assigneePosition,
      task?.assigneeId,
      task?.taskStatus,
    ]
  );

  return (
    <div
      className={clsx(
        'tw-flex',
        'tw-items-center',
        'tw-pb-[4px]',
        'tw-justify-between',
        'tw-min-w-0'
      )}
      {...props}
    >
      <div className="tw-flex tw-items-center tw-min-w-0 tw-flex-1">
        <EmployeeAvatar
          name={user.name}
          avatar={user.avatar}
          position={user.position}
          data-tooltip-id="assignee_avatar_tooltip"
          data-tooltip-content={`${user.name} - ${user.position || ''}`}
        />
        <div className="tw-truncate tw-text-black tw-ml-2 tw-text-[12px]">{user.name}</div>
      </div>
      {!hideTags && (task.isMilestone || task.hasReport) ? (
        <div className="tw-ml-2 tw-flex-shrink-0 tw-text-right">
          <TaskStatusPill
            isMilestone={task.isMilestone}
            hasReport={task.hasReport}
            isCalendar
            style={{ fontSize: '0.8em', height: '22px' }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default Assignee;
